import { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import courseConfig from './config/course';
import Hero from './components/Hero';
import Features from './components/Features';
import Testimonials from './components/Testimonials';
import Pricing from './components/Pricing';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import CheckoutModal from './components/CheckoutModal';
import AdminDashboard from './components/AdminDashboard';

function App() {
  const [showCheckout, setShowCheckout] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    setIsAdmin(window.location.pathname === '/admin');
  }, []);

  const siteUrl = `https://${courseConfig.courseId}.lidacourses.com`;

  if (isAdmin) {
    return <AdminDashboard onBack={() => { window.location.href = '/'; }} />;
  }

  return (
    <div className="app">
      <Helmet>
        <title>{courseConfig.courseName} | LidaCourses</title>
        <meta name="description" content={`${courseConfig.tagline}. Download now and pay in your local currency — 14 currencies supported.`} />
        <link rel="canonical" href={siteUrl} />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content={`${courseConfig.courseName} | LidaCourses`} />
        <meta property="og:description" content={courseConfig.tagline} />
        <meta property="og:url" content={siteUrl} />
        <meta property="og:site_name" content="LidaCourses" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={`${courseConfig.courseName} | LidaCourses`} />
        <meta name="twitter:description" content={courseConfig.tagline} />
      </Helmet>

      <Hero onGetCourse={() => setShowCheckout(true)} />
      <Features />
      <Testimonials />
      <Pricing onGetCourse={() => setShowCheckout(true)} />
      <FAQ />
      <Footer />

      {showCheckout && (
        <CheckoutModal onClose={() => setShowCheckout(false)} />
      )}
    </div>
  );
}

export default App;
